
import { COMPANY_NAME, COMPANY_DOMAIN, CONTACT_EMAIL, COMPANY_ADDRESS} from '../config';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  
  return (
    <div className="mx-auto max-w-3xl px-6 my-20">
      <div className="text-left">
        <h1>Privacy Policy</h1>
        <h2 className="mt-8">Privacy Policy for {COMPANY_NAME}</h2>
        <p>This Privacy Policy explains how {COMPANY_NAME} ("we", "us", or "our") collects, uses, and discloses your information when you use our platform located at {COMPANY_DOMAIN}. It also explains your rights concerning your personal information and how you can exercise them.</p>

        <h2 className="mt-8">Information We Collect</h2>
        <p>We collect different types of information from or about you depending on how you use our platform. This may include:</p>
        <ul className="list-disc ml-5">
          <li><span className="font-bold">Personal Identification Information:</span> Name, email address, phone number, etc.</li>
          <li><span className="font-bold">Usage Data:</span> Information about how you interact with our platform, such as your IP address, browser type, and the pages you visit.</li>
          <li><span className="font-bold">Transaction Data:</span> Details of any transactions you carry out via our platform.</li>
        </ul>

        <h2 className="mt-8">How We Use Your Information</h2>
        <p>We may use the information we collect in various ways, including to:</p>
        <ul className="list-disc ml-5">
          <li>Provide, operate, and maintain our platform</li>
          <li>Improve, personalize, and expand our platform</li>
          <li>Understand and analyze how you use our platform</li>
          <li>Process your transactions</li>
          <li>Communicate with you, including for customer service, support, and updates</li>
        </ul>

        <h2 className="mt-8">How We Share Your Information</h2>
        <p>We may share your information with third parties in the following circumstances:</p>
        <ul className="list-disc ml-5">
          <li><span className="font-bold">Service Providers:</span> We may share your information with third-party vendors and service providers who perform services on our behalf.</li>
          <li><span className="font-bold">Business Transfers:</span> If {COMPANY_NAME} is involved in a merger, acquisition, or asset sale, your information may be transferred.</li>
          <li><span className="font-bold">Legal Requirements:</span> We may disclose your information if required to do so by law or in response to valid requests by public authorities.</li>
        </ul>

        <h2 className="mt-8">Your Data Protection Rights</h2>
        <p>You have the following data protection rights:</p>
        <ul className="list-disc ml-5">
          <li><span className="font-bold">Right to Access:</span> You have the right to request copies of your personal data.</li>
          <li><span className="font-bold">Right to Rectification:</span> You have the right to request that we correct any information you believe is inaccurate.</li>
          <li><span className="font-bold">Right to Erasure:</span> You have the right to request that we erase your personal data under certain conditions.</li>
          <li><span className="font-bold">Right to Restrict Processing:</span> You have the right to request that we restrict the processing of your personal data under certain conditions.</li>
        </ul>

        <h2 className="mt-8">How to Contact Us</h2>
        <p>If you have any questions about this Privacy Policy or how we handle your data, please contact us at:</p>
        <p>Email: {CONTACT_EMAIL}</p>
        <p>Address: {COMPANY_ADDRESS}</p>

        <h2 className="mt-8">Changes to this Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time to reflect changes to our practices or for other operational, legal, or regulatory reasons. Please review this page regularly to stay informed about how we are protecting your information.</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
